import { ActionIcon, Button, Group, Menu, Title } from '@mantine/core';
import { useSetupStore } from '../../store';
import { useNotify } from '@/hooks';
import { Container, ContentWrapper, StyledScrollArea } from './styles';
import {
  CategoryPopover,
  TemplateAccordion,
  TemplateSelectHeader,
} from '../../molecules';
import { SortOrder } from '../../molecules/template-accordion/template-accordion';
import { CreateTemplateModal } from '../create-template-modal';
import { ConfigTemplateModal } from '../config-template-modal';
import { t } from 'i18next';
import { useState } from 'react';
import { MdSort } from 'react-icons/md';

export interface TemplateSelectProps {
  children: (progress: () => void, disabled?: boolean) => JSX.Element;
}

export const TemplateSelect = ({ children }: TemplateSelectProps) => {
  const [
    setIsCreateModalOpen,
    templateId,
    step,
    setCurrentStep,
    selectedTemplateId,
  ] = useSetupStore((s) => [
    s.setIsCreateModalOpen,
    s.templateId,
    s.currentStep,
    s.setCurrentStep,
    s.selectedTemplateId,
  ]);
  const { warn } = useNotify();
  const [sort, setSort] = useState<SortOrder>('recent');

  const handleCreateModal = () => {
    setIsCreateModalOpen(true);
  };

  const progressSetup = () => {
    if (templateId === undefined) {
      warn(t('message.warning.selectTemplate'));

      return;
    }

    setCurrentStep(step + 1);
  };

  return (
    <>
      <Container>
        <ContentWrapper>
          <Title order={3} fw={500}>
            {t('title.templateSelect')}
          </Title>

          <TemplateSelectHeader>
            <Group spacing="xs">
              <Menu position="bottom-end">
                <Menu.Target>
                  <Button variant="default" leftIcon={<MdSort />}>
                    {t('menu.sort.label')}
                  </Button>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item
                    style={{
                      color: sort === 'recent' ? 'normal' : 'grey',
                    }}
                    onClick={() => setSort('recent')}
                  >
                    {t('menu.sort.recent')}
                  </Menu.Item>
                  <Menu.Item
                    style={{
                      color: sort === 'priority' ? 'normal' : 'grey',
                    }}
                    onClick={() => setSort('priority')}
                  >
                    {t('menu.sort.priority')}
                  </Menu.Item>
                  <Menu.Item
                    style={{
                      color: sort === 'name-asc' ? 'normal' : 'grey',
                    }}
                    onClick={() => setSort('name-asc')}
                  >
                    {t('menu.sort.name-asc')}
                  </Menu.Item>
                  <Menu.Item
                    style={{
                      color: sort === 'name-desc' ? 'normal' : 'grey',
                    }}
                    onClick={() => setSort('name-desc')}
                  >
                    {t('menu.sort.name-desc')}
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
              <CategoryPopover />
            </Group>
          </TemplateSelectHeader>

          <StyledScrollArea h={600} scrollbarSize={4}>
            <TemplateAccordion sort={sort} />
          </StyledScrollArea>

          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Button onClick={handleCreateModal}>
              {t('button.createTemplate')}
            </Button>
          </div>
        </ContentWrapper>
      </Container>

      <CreateTemplateModal />
      {selectedTemplateId && <ConfigTemplateModal />}

      {children(progressSetup)}
    </>
  );
};
